



































































































import { editFactory } from '@/main/pages';
import { formatDecimalValue } from '@/main/utils/stringHelper';

import { store } from './store/edit';
import { NAME, PARTS_AND_LABOURS } from './constants';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	data(){
		return{
			dependencies: {
				[PARTS_AND_LABOURS]: PARTS_AND_LABOURS,
			}
		}
	},
	computed: {
		formattedAmount() {
			return this.Amount != null ? formatDecimalValue(this.Amount) : this.Amount;
		},
	},
});
